// pricing table for Khanmigo
export const pricing = {
    // pricing in USD
    khanmigoUS: {monthly: 4, yearly: 44},
};

export function getStripeCheckoutPrice() {
    return process.env.NODE_ENV === "development"
        ? "price_1OJhEvLkDs2kpeJzvN1MDVc5" // Test price
        : "price_1O9YpaLkDs2kpeJzw7q6QWWZ"; // Prod price
}

export const couponID =
    process.env.NODE_ENV === "development"
        ? "bxZrFVog" // Test coupon
        : "pW5UxUE1"; // Prod coupon - $4 off / first month free
